// @flow

import * as React from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import * as icons from '../icons';

class Adornment extends React.PureComponent {
  render() {
    const { icon, position = 'start' } = this.props;
    const Icon = icons[icon];
    return (
      Icon && (
        <InputAdornment position={position}>
          <Icon style={{ opacity: 0.4 }} />
        </InputAdornment>
      )
    );
  }
}

export default Adornment;
